import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { ClientePipeSharedModule } from '../../../pessoa/cliente/pipes';
import { CustomerShareIndicadorPipeModule } from '../../../pic/customer-share/indicador/pipes';
import { PedidoEmailModule } from '../../email';
import { PedidoCancelamentoModule } from '../../cancelamento';
import { PedidoLiberarModalModule } from '../../nao-liberado/components/liberar-modal';
import { PedidoNaoLiberadoPipeModule } from '../../nao-liberado/pipes';
import { PedidoDRPLucroLiquidoBadgeModule } from '../../drp/components/lucro-liquido-badge';

import { PedidoPedidoListComponent } from './pedido-pedido-list.component';

@NgModule({
    imports: [
        SharedModule,
        PedidoEmailModule,
        PedidoCancelamentoModule,
        PedidoLiberarModalModule,
        PedidoNaoLiberadoPipeModule,
        ClientePipeSharedModule,
        CustomerShareIndicadorPipeModule,
        PedidoDRPLucroLiquidoBadgeModule
    ],
    declarations: [
        PedidoPedidoListComponent
    ],
    exports: [
        PedidoPedidoListComponent
    ]
})
export class PedidoPedidoListModule { }
